import { useEffect, useState } from 'react'
import { queryConfigListForCompany } from '@/services/user'

/*
 * 获取快捷查询项-商家维度
 */
export const useGetConfigListForCompany = (configKey: string, refresh: boolean) => {
    const [info, setInfo] = useState({})
    const [loading, setLoading] = useState(false)
    const fetchData = async () => {
        if (!configKey) {
            return
        }
        setLoading(true)
        try {
            const { success, data, message } = await queryConfigListForCompany({
                configKey
            })
            if (success) {
                setInfo(data)
            } else {
                console.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        fetchData()
    }, [configKey, refresh])

    return [info, loading]
}
